import { useParams, useNavigate } from 'react-router-dom';
import { Row, Col, Button } from 'react-bootstrap';
import { FiArrowLeft, FiEdit2, FiMapPin } from 'react-icons/fi';
import Card from '../Components/Card';
import Timeline from '../Components/Timeline';
import EmptyState from '../Components/EmptyState';
import { useRetailer, useRetailerStations, useRetailerVisits } from '../hooks/useRetailers';
import { formatDate } from '../utils/format';

function Field({ label, value }) {
  return (
    <div style={{ marginBottom: 10 }}>
      <div className="hrms-muted" style={{ fontSize: '0.75rem', textTransform: 'uppercase' }}>{label}</div>
      <div>{value || <span className="hrms-muted">—</span>}</div>
    </div>
  );
}

export default function RetailerDetailPage() {
  const { cmGuid } = useParams();
  const navigate = useNavigate();
  const { data: r, isLoading, isError, error } = useRetailer(cmGuid);
  const { data: stations } = useRetailerStations(cmGuid);
  const { data: visits } = useRetailerVisits(cmGuid);

  if (isLoading) return <div className="hrms-page"><span className="hrms-muted">Loading…</span></div>;
  if (isError) return <div className="hrms-page"><div className="hrms-field-error">{error?.friendlyMessage || 'Failed to load retailer.'}</div></div>;

  return (
    <div className="hrms-page">
      <div className="hrms-toolbar">
        <h1 className="hrms-page-title">{r?.customerName}</h1>
        <div className="d-flex gap-2">
          <Button variant="light" onClick={() => navigate('/retailers')}><FiArrowLeft className="me-1" /> Back</Button>
          <Button variant="light" onClick={() => navigate(`/retailers/${cmGuid}/checkin`)}><FiMapPin className="me-1" /> Check-in</Button>
          <Button className="hrms-btn-primary" onClick={() => navigate(`/retailers/${cmGuid}/edit`)}><FiEdit2 className="me-1" /> Edit</Button>
        </div>
      </div>

      <Row>
        <Col md={7}>
          <Card title="Profile" className="mb-3">
            <Row>
              <Col sm={6}><Field label="Code" value={r?.customerCode} /></Col>
              <Col sm={6}><Field label="Mobile" value={[r?.mobileCountryCode, r?.mobileNumber].filter(Boolean).join(' ')} /></Col>
              <Col sm={6}><Field label="GSTIN" value={r?.gstin} /></Col>
              <Col sm={6}><Field label="PAN" value={r?.pan} /></Col>
              <Col sm={6}><Field label="City" value={r?.cityName} /></Col>
              <Col sm={6}><Field label="State" value={r?.regionName} /></Col>
              <Col sm={6}><Field label="District" value={r?.districtName} /></Col>
              <Col sm={6}><Field label="Tehsil" value={r?.tehsilName} /></Col>
              <Col sm={6}><Field label="Pincode" value={r?.pincode} /></Col>
              <Col sm={6}><Field label="Country" value={r?.countryCode} /></Col>
            </Row>
          </Card>

          <Card title="Ownership (stations)" className="mb-3">
            {stations?.length ? (
              <ul className="mb-0">
                {stations.map((s) => <li key={s.stationGuid}>{s.stationName}{s.officeCode ? ` (${s.officeCode})` : ''}</li>)}
              </ul>
            ) : <EmptyState message="No station mapped." />}
          </Card>
        </Col>

        <Col md={5}>
          <Card title="Visit history">
            <Timeline
              emptyMessage="No check-ins recorded yet."
              items={(visits || []).map((v) => ({
                id: v.punchInGuid,
                date: formatDate(v.punchDate),
                title: v.visitOutcome || 'Check-in',
                subtitle: [v.address, (v.latitude && v.longitude) ? `${v.latitude}, ${v.longitude}` : null].filter(Boolean).join('  ·  '),
                body: v.notes,
              }))}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
}
